module.exports = __webpack_public_path__ + "img/id_eg.6a75d8fd.jpg";